import classNames from 'classnames';
import { useContext, useEffect, useState } from 'react';
import SelectCollectionViewTemplate from '../../../../CollectionSettingsComponents/SelectCollectionViewTemplate';
import EditorTool from '../../../EditorTool';
import { CollectionSettingsPathContext } from '../../../context/CollectionSettingsContextProvider/pathContext';
import { TextEditorContext } from '../../../context/TextEditorContext';
import { useTEditorRef } from '../../../plate';
import { BLOCK_ELEMENT_KEY } from '../../../types';
import styles from '../CollectionSettings.module.css';
import { DEFAULT_ITEMS_PER_ROW, SETTINGS_PAGE } from '../constants';
import {
  CollectionSettingsDataContext,
  CollectionSettingsPageDispatchContext,
} from '../contextProvider';

function Template() {
  const editor = useTEditorRef();
  const path = useContext(CollectionSettingsPathContext);
  const setSettingsPage = useContext(CollectionSettingsPageDispatchContext);
  const [itemPerRow, setitemPerRow] = useState<number>(DEFAULT_ITEMS_PER_ROW);
  const [loading, setloading] = useState(false);
  const { element, collectionData, editorSyncData, listColumns, grabElement } = useContext(
    CollectionSettingsDataContext
  );
  const originalTemplate = element?.[BLOCK_ELEMENT_KEY.COLLECTION_TEMPLATE];

  const [template, settemplate] = useState(originalTemplate);
  const templateCustomized = originalTemplate?.custom;

  const { save } = useContext(TextEditorContext);

  useEffect(() => {
    if (template?.settings) {
      setitemPerRow(template?.settings?.numCol);
    }
  }, [template]);

  const onUseTemplate = async () => {
    setloading(true);
    EditorTool.setBlockProperty(editor, BLOCK_ELEMENT_KEY.COLLECTION_TEMPLATE, template, {
      at: path,
    });
    await editorSyncData(collectionData);
    await save();
    setloading(false);
    grabElement(path);
  };

  const goToCustomize = () => {
    setSettingsPage(SETTINGS_PAGE.CUSTOMIZE_TEMPLATE);
  };

  const onUpdateTemplateSettings = async () => {
    const updatedTemplate = { ...originalTemplate };
    updatedTemplate.settings = {
      ...template.settings,
      numCol: itemPerRow,
    };
    EditorTool.setBlockProperty(editor, BLOCK_ELEMENT_KEY.COLLECTION_TEMPLATE, updatedTemplate, {
      at: path,
    });
    settemplate(updatedTemplate);
    await editorSyncData(collectionData);
    grabElement(path);
  };

  return (
    <div
      className={classNames(styles.containerItem, styles.containerWithSidebar, 'pl-6 pt-6 pb-6')}
    >
      <SelectCollectionViewTemplate
        loading={loading}
        onUseTemplate={onUseTemplate}
        originalTemplate={originalTemplate}
        setdefaultItemPageTemplate={() => {
          /*  */
        }}
        template={template}
        settemplate={settemplate}
        templateCustomized={templateCustomized}
        goToCustomizeTemplate={goToCustomize}
        showSaveSettings
        showUseTemplate
        onUpdateTemplateSettings={onUpdateTemplateSettings}
        itemPerRow={itemPerRow}
        setitemPerRow={setitemPerRow}
        showTemplateSettings
        showCustomizeTemplate
        collectionData={collectionData}
        listColumns={listColumns}
        element={element as any}
      />
    </div>
  );
}

export default Template;
